/************  GESTION DES BLOCS *****************/

    $(window).load(setupBlocks);

    function setupBlocks() {
        initSlickSlider();
        initBlockMedia();
        initBlockTabs();
        initBlockSolutions();
        initBlockSound();
        initBlockContact();
        initBlockSlider();
        initDownloadBlock();
        initDataLayers();
    }

    // Fonction pour initialiser les sliders avec Slick
    function initSlickSlider() {
        // Bloc Focus
        $('.blockfocus').each(function() {
            var textSlider = $(this).find('.slidetxt');
            var imgSlider = $(this).find('.slideimg');
            if(textSlider.children('.slide').length > 1) {
                imgSlider.slick({
                    dots: false,
                    arrows: false,
                    infinite: false,
                    speed: 600,
                    fade: true,
                    adaptiveHeight: false,
                    slidesToShow: 1,
                    asNavFor: textSlider
                });
                textSlider.slick({
                    dots: false,
                    arrows: true,
                    infinite: false,
                    speed: 600,
                    fade: false,
                    adaptiveHeight: true,
                    slidesToShow: 1,
                    prevArrow: '<button type="button" class="slick-prev">Précédent</button>',
                    nextArrow: '<button type="button" class="slick-next">Suivant</button>',
                    appendArrows: $(this).find('.slicknav'),
                    asNavFor: imgSlider
                });
            }
        });

        // Bloc Rebond
        $('.blockbounce').each(function() {
            let bloc = $(this);
            bloc.find('.blockbounce-slider .slider').slick({
                dots: false,
                arrows: false,
                infinite: false,
                speed: 400,
                touchThreshold: 15,
                swipeToSlide: true,
                edgeFriction: 0,
                fade: false,
                autoplay: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                adaptiveHeight: false,
                slidesToShow: 3,
                slidesToScroll: 2,
                cssEase: 'ease-in-out',
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"></button>',
                appendArrows: bloc.find('.slicknav'),
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            variableWidth: true
                        }
                    },
                    {
                        breakpoint: 675,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            variableWidth: true
                        }
                    }
                ]
            });
        });

        // Bloc Réassurance
        $('.blockreinsurance').each(function() {
            let bloc = $(this);
            bloc.find('.blockreinsurance-cards').slick({
                dots: false,
                arrows: true,
                infinite: false,
                speed: 400,
                touchThreshold: 15,
                swipeToSlide: true,
                edgeFriction: 0,
                fade: false,
                autoplay: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                adaptiveHeight: false,
                slidesToShow: 3,
                slidesToScroll: 2,
                cssEase: 'ease-in-out',
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"></button>',
                appendArrows: bloc.find('.slicknav'),
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            variableWidth: true
                        }
                    },
                    {
                        breakpoint: 675,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            variableWidth: true
                        }
                    }
                ]
            });
        });

        // Bloc Slider Produits
        $('.blocksliderpdts').each(function() {
            let bloc = $(this);
            bloc.find('.blocksliderpdts-slides').slick({
                dots: false,
                arrows: true,
                infinite: false,
                speed: 400,
                touchThreshold: 15,
                swipeToSlide: true,
                edgeFriction: 0,
                fade: false,
                autoplay: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                adaptiveHeight: false,
                slidesToShow: 4,
                slidesToScroll: 2,
                cssEase: 'ease-in-out',
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"></button>',
                appendArrows: bloc.find('.slicknav'),
                responsive: [
                    {
                        breakpoint: 1360,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 675,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            variableWidth: true
                        }
                    }
                ]
            });
        });

        // Bloc Slider Solutions
        $('.blocksolutions').each(function() {
            let bloc = $(this);
            bloc.find('.blocksolutions-images .slideimg').slick({
                dots: false,
                arrows: true,
                infinite: false,
                speed: 400,
                touchThreshold: 15,
                swipeToSlide: true,
                edgeFriction: 0,
                fade: false,
                autoplay: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                adaptiveHeight: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                cssEase: 'ease-in-out',
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"></button>',
                appendArrows: bloc.find('.slicknav'),
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 760,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        });

        // Bloc Remontée de réalisations
        $('.blockslidereal').each(function() {
            let bloc = $(this);
            bloc.find('.blockslidereal-slider .slider').slick({
                dots: false,
                arrows: true,
                infinite: false,
                speed: 400,
                touchThreshold: 15,
                swipeToSlide: true,
                edgeFriction: 0,
                fade: false,
                autoplay: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                adaptiveHeight: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                cssEase: 'ease-in-out',
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"></button>',
                appendArrows: bloc.find('.slicknav')
            });
        });

        // Bloc Témoignage Recrutement
        $('.blockjobtestimony').each(function() {
            let bloc = $(this);
            bloc.find('.blockjobtestimony-testimonies .slider').slick({
                dots: false,
                arrows: true,
                infinite: false,
                speed: 400,
                touchThreshold: 15,
                swipeToSlide: true,
                edgeFriction: 0,
                fade: false,
                autoplay: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                adaptiveHeight: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                cssEase: 'ease-in-out',
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"></button>',
                appendArrows: bloc.find('.slicknav'),
                asNavFor: $('.blockjobtestimony-img .slider')
            });
            bloc.find('.blockjobtestimony-img .slider').slick({
                dots: false,
                arrows: false,
                infinite: false,
                speed: 300,
                touchThreshold: 15,
                swipeToSlide: false,
                edgeFriction: 0,
                fade: true,
                autoplay: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                adaptiveHeight: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                cssEase: 'ease-in-out',
                asNavFor: $('.blockjobtestimony-testimonies .slider')
            });
        });

        // Bloc Remontée de réalisations
        $('.blocktabs').each(function() {
            let bloc = $(this);
            bloc.find('.blocktabs-tabs').slick({
                dots: false,
                arrows: true,
                infinite: false,
                speed: 400,
                touchThreshold: 15,
                swipeToSlide: true,
                edgeFriction: 0,
                fade: false,
                autoplay: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                adaptiveHeight: false,
                slidesToScroll: 1,
                slidesToShow: 6,
                variableWidth: true,
                cssEase: 'ease-in-out',
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"></button>',
                responsive: [
                    {
                        breakpoint: 1360,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 760,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        });

        // Bloc Carrefour
        var blocJunctionSlick = [];
        $('.blockjunction').each(function(index) {
            var bloc = $(this);
            var settingsBlocJunction = {
                dots: false,
                arrows: false,
                infinite: false,
                speed: 400,
                touchThreshold: 15,
                swipeToSlide: true,
                edgeFriction: 0,
                fade: false,
                autoplay: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                variableWidth: true,
                adaptiveHeight: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                cssEase: 'ease-in-out',
                prevArrow: '<button aria-label="Aller à la slide précédente" type="button" class="slick-prev icon-prev"></button>',
                nextArrow: '<button aria-label="Aller à la prochaine slide" type="button" class="slick-next icon-prev"></button>',
                appendArrows: bloc.find('.slicknav'),
                responsive: [
                    {
                        breakpoint: 5000,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 650,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            };
            blocJunctionSlick[index] = bloc.find('.blockjunction-grid').slick(settingsBlocJunction);
            $(window).on('resize', function() {
                if( $(window).width() < 1000 && !blocJunctionSlick[index].hasClass('slick-initialized')) bloc.find('.blockjunction-grid').slick(settingsBlocJunction);
            });
        });
    }

    // Fonction qui permet de lire une vidéo
    function initBlockMedia() {
        $('.blocktextimg-media.has-video, .blockmedia-media.has-video').click(function() {
            if(!$(this).hasClass('showVideo'))  {
                $(this).addClass('showVideo');
                // Lecture des vidéos Youtube et Vimeo
                var videoUrl = $(this).find("iframe").attr('src');
                $(this).find(".video_player iframe").attr('allow', 'autoplay; fullscreen');
                if(videoUrl.split('?').length > 0) videoUrl = videoUrl.split('?')[0]
                $(this).find(".youtube_player iframe").attr('src', videoUrl + '?theme=light&rel=0&controls=1&showinfo=0&autoplay=1');
                $(this).find(".vimeo_player iframe").attr('src', videoUrl + '?autoplay=1');
            }
        });
    }

    // Fonction pour gérer le bloc onglet
    function initBlockTabs() {
        $('.blocktabs').each(function() {
            var block = $(this);
            block.children('.blocktabs-content').css('min-height', $(this).children('.blocktabs-content').children('.contentab:first-child').height() + 'px');

            block.find('.btn-tab').click(function() {
                if(!$(this).hasClass('current')) {
                    var tabId = $(this).attr('id').split('btntab-');
                    block.children('.blocktabs-tabs').find('.current').removeClass('current');
                    $(this).addClass('current');
                    block.children('.blocktabs-content').find('.current').removeClass('current');
                    setTimeout(function () {
                        $('#tab-' + tabId[1]).addClass('current');
                        block.children('.blocktabs-content').css('min-height', $('#tab-' + tabId[1]).innerHeight() + 'px');
                    }, 300);
                }
            });

            $(window).resize(function() {
                block.children('.blocktabs-content').css('min-height', block.children('.blocktabs-content').children('.contentab.current').innerHeight() + 'px');
            });
        });
    }

    // Fonction pour gérer les players audio personnalisés
    function initBlockSound() {
        $('.blocksound').each(function() {
            let audio = $(this).find('audio');
            let timeline = $(this).find('.piste');

            // Lancer ou couper le player
            const playBtn = $(this).find('.btn-play');
            playBtn.click(function() {
                if(audio[0].paused) {
                    $(this).removeClass('play');
                    $(this).addClass('pause');
                    audio.trigger("play");
                }else {
                    $(this).removeClass('pause');
                    $(this).addClass('play');
                    audio.trigger("pause");
                }
            });

            // Au clic sur la timeline on va au temps correspondant
            timeline.on('click', function(e) {
                var audioDuration = audio[0].duration;
                var timelineWidth = $(this).innerWidth();
                const timeToSeek = e.offsetX / parseInt(timelineWidth) * audioDuration;
                audio[0].currentTime = timeToSeek;
                $(this).parent().find('.timer').children('.current').html(convertTimer(timeToSeek));
                $(this).parent().find('.piste-timer').css('width', timeToSeek / audioDuration * 100 + "%");
            });

            // On met à jour l'avancement du timer
            setInterval(() => {
                const progressBar =  $(this).find('.piste-timer');
                var audioCurTime = audio[0].currentTime;
                var audioDuration = audio[0].duration;
                // On récupère la durée totale de l'audio
                if(audioDuration !== 'NaN') $(this).find('.timer').children('.total').html(convertTimer(audioDuration));
                progressBar.css('width', audioCurTime / audioDuration * 100 + "%");
                $(this).find('.timer').children('.current').html(convertTimer(audioCurTime));

                // Si on arrive à la fin on met en pause le lecteur
                if(audioCurTime === audioDuration) {
                    $(this).find('.btn-play').addClass('play');
                    $(this).find('.btn-play').removeClass('pause');
                }
            }, 500);
        });
    }

    // Fonction pour gérer le bloc solutions
    function initBlockSolutions() {
        $('.blocksolutions').each(function() {
            let bloc = $(this);
            bloc.find('.blocksolutions-slideupdown li').click(function() {
                if($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $(this).find('.content').slideUp(300);
                }else {
                    bloc.find('.active .content').slideUp(300);
                    bloc.find('.active').removeClass('active');
                    $(this).find('.content').slideDown(300);
                    $(this).addClass('active');
                }
            });
        });
    }

    // Fonction pour gérer le scroll du texte dans le bloc slider produits
    function initBlockSlider() {
        $('.blocksliderpdts').each(function() {
            let bloc = $(this);
            bloc.find('.product').each(function() {
                if($(this).find('.product-text .scrolldiv').innerHeight() > 120)
                    $(this).find('.product-text').mCustomScrollbar();
            });
        });
    }

    // Conversion du temps en string
    function convertTimer(d) {
        var convertTimer = '';
        var d = Number(d);
        var h = Math.floor(d / 3600);
        var m = Math.floor(d % 3600 / 60);
        var s = Math.floor(d % 3600 % 60);

        if(h !== 0) convertTimer = (h < 10) ? h + ':' : h + ':';
        convertTimer = (m < 10) ? convertTimer + m + ':' : convertTimer + m + ':';
        convertTimer = (s < 10) ? convertTimer + '0' + s : convertTimer + s;
        return convertTimer;
    }

    // Bloc Formulaire de Contact avec map
    function initBlockContact() {
        if($('.blockcontact').length !== 0) {
            var centerCoords = { lat: 46.73996400905074, lng: 2.1998883464865093 };
            var zoom = 5;
            var zoomLimits = {
                min: 5,
                max: 20
            };
            //https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}
            var tileLayer2D = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';
            window.layer2D = L.tileLayer(tileLayer2D, {
                minZoom: zoomLimits.min,
                maxZoom: zoomLimits.max,
                //detectRetina: true,
                reuseTiles: true
            });
            var map = L.map('map', {
                center: centerCoords,
                zoom: zoom,
                minZoom: zoomLimits.min,
                maxZoom: zoomLimits.max,
                touchZoom: true,
                keyboard: false,
                attributionControl: false,
                scrollWheelZoom: false,
                trackResize: true,
                fadeAnimation: true,
                zoomAnimation: true,
                layerControl: false,
                layers: [layer2D]
            });
            $('.blockcontact').find('.marker').children('li').each(function( index ) {
                var id = $(this).attr('id');
                var latitude = $(this).attr('data-latitude');
                var longitude = $(this).attr('data-longitude');
                var title = $(this).attr('data-title');
                var desc = $(this).attr('data-address');
                var myIcon = L.divIcon({
                    className: ' cluster ' + id,
                    iconSize: [34, 34],
                    iconAnchor: [17, 34],
                    html: '<div class="mapoint"><div class="markup"></div><div class="content"><div class="title">' + title + '</div><p>' + desc + '</p><button class="btn btn-close-cluster"><span>Fermer</span><span class="icon">X</span></button></div></div>'
                });
                var marker = L.marker([latitude, longitude], {icon: myIcon}).on('click', showAgencyInfos).addTo(map);
            });
        }
    }

    // Bloc Télécharger un document
    function initDownloadBlock() {
        $('.blockdownload .loadMore').click(function() {
            if(!$(this).parent().hasClass('showAll')) {
                $(this).parent().addClass('showAll');
                $(this).fadeOut(200);
            }
        });
        
        $('.blockdownload a').click(function() {
            if($(this).data('event') !== undefined) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: $(this).data('event'),
                    resource_name: $(this).parent().parent().find('.title').html().trim()
                });
            }
        });
    }

    // Affichage des infos des agence au clic sur les clusters
    function showAgencyInfos() {
        let clusterClass = this._icon.classList[2];
        let clusterID = clusterClass.split('marker-');
        $('.currentmarker').removeClass('currentmarker');
        this._icon.classList += ' currentmarker';

        $('.blockcontact-map .marker').each(function( index ) {
            $(this).removeClass('currentShow');
            if(parseInt(clusterID[1]) === parseInt($(this).attr('id'))) $(this).addClass('currentShow');
        });

        $('.btn-close-cluster').click(function(event) {
            event.preventDefault();
            event.stopPropagation();
            $(this).parent().parent().parent().removeClass('currentmarker');
            $('.blockcontact-map .marker').removeClass('currentShow');
        });
    }
    
    // Fonction pour envoyer des data layers sur le bloc entités
    function initDataLayers() {
        // Block Search Hompe
        $('.homepage .header-search .btn-main').click(function() {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'search_projet_dedie',
                project_type: $('select#project option:selected').text()
            });
        });
        
        // Block Tabs
        $('.homepage .blocktabs .btn-tab').click(function(e) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'clic_menu_central',
                tab_name: $(this).html().trim(),
                button_name: $(this).html().trim()
            });
        });
        $('.homepage .blocktabs .cardlink-link').click(function(e) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'clic_menu_central',
                tab_name: $(this).parent().parent().parent().parent().parent().parent().parent().find('.btn-tab.current').html().trim(),
                button_name: $(this).find('span').html().trim()
            });
        });
        
        // Block Entity
        $('.blockentity .entity-text a[data-entity]').click(function(e) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'clic_site_entite',
                site_entite: $(this).data('entity')
            });
        });
        
        // Spotlight News on Header Homepage
        $('.homepage .header-push .content').click(function(e) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'clic_actu_du_jour',
                actu_name: $(this).find('.title').html().trim()
            });
        });
    }